import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const options = {
	order: ["navigator"],
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		detection: options,
		compatibilityJSON: "v3",
		fallbackLng: "en",
		resources: {
			en: {
				translations: require("./locales/en/translations.json"),
			},
			es: {
				translations: require("./locales/es/translations.json"),
			},
			ca: {
				translations: require("./locales/es/translations.json"),
			},
			eu: {
				translations: require("./locales/es/translations.json"),
			},
			gl: {
				translations: require("./locales/es/translations.json"),
			},
		},
		nonExplicitSupportedLngs: true,
		ns: ["translations"],
		defaultNS: "translations",
	});

i18n.languages = ["en", "es", "ca", "eu", "gl"];

export default i18n;
